import { motion } from "framer-motion";
import { INTEGRATIONS, integrationTestId } from "@/config/integrations";

const LogoChip = ({ name, logo }) => (
  <div
    className="flex h-14 flex-none items-center gap-3 rounded-xl border border-border bg-card px-5 shadow-sm transition-all hover:-translate-y-0.5 hover:border-foreground/30 hover:shadow-md"
    data-testid={`integration-${integrationTestId(name)}`}
  >
    <span className="inline-flex h-8 w-8 flex-none items-center justify-center rounded-md bg-white shadow-inner ring-1 ring-black/5">
      <img
        src={logo}
        alt={`${name} logo`}
        loading="lazy"
        className="h-5 w-5 object-contain"
        onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
      />
    </span>
    <span className="whitespace-nowrap text-sm font-semibold tracking-tight text-foreground/85">
      {name}
    </span>
  </div>
);

/* Infinite marquee — duplicates the list and translates -50% so the loop is seamless.
   Hover anywhere on the strip to pause. */
export const IntegrationsSlider = () => {
  const loop = [...INTEGRATIONS, ...INTEGRATIONS];
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.55 }}
      className="mt-16 sm:mt-20"
      data-testid="integrations-slider"
    >
      <style>{`
        @keyframes clinicos-marquee {
          from { transform: translate3d(0, 0, 0); }
          to   { transform: translate3d(-50%, 0, 0); }
        }
        .clinicos-marquee-track {
          animation: clinicos-marquee 60s linear infinite;
        }
        .clinicos-marquee-wrap:hover .clinicos-marquee-track {
          animation-play-state: paused;
        }
      `}</style>

      <div className="flex flex-col items-center gap-3 text-center">
        <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
          Plug into the tools you already use
        </span>
        <p className="mx-auto max-w-3xl text-base leading-relaxed text-muted-foreground sm:text-lg lg:text-xl">
          <span className="font-semibold text-foreground/85">Calendars</span>{" · "}
          <span className="font-semibold text-foreground/85">Messaging</span>{" · "}
          <span className="font-semibold text-foreground/85">Marketing</span>{" · "}
          <span className="font-semibold text-foreground/85">Payments</span>{" · "}
          <span className="font-semibold text-foreground/85">EMR</span>{" "}— all under one login.
        </p>
      </div>

      <div
        className="clinicos-marquee-wrap group relative mt-8 overflow-hidden"
        style={{
          maskImage: "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage: "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
        }}
      >
        <div className="clinicos-marquee-track flex w-max items-stretch gap-4">
          {loop.map((it, i) => (
            <LogoChip key={`${it.name}-${i}`} {...it} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};
